import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

import { ToastState } from "../toast/toast";

const DEFAULT_SUCCESS_MESSAGE = "Success";
const DEFAULT_ERROR_MESSAGE = "Error";

@Injectable({
    providedIn: "root"
})

export class ToastService {

    private toastSubject = new Subject<ToastState>();

    toastState = this.toastSubject.asObservable();

    constructor() { }

    success(message: string = DEFAULT_SUCCESS_MESSAGE): void {
        this.show(true, message);
    }

    error(message: string = DEFAULT_ERROR_MESSAGE): void {
        this.show(false, message);
    }

    private show(success: boolean, message: string): void {
        this.toastSubject.next({ show: true, success, message } as ToastState);
    }
}
